import * as React from "react";
import styles from "./Command.module.css";
import { Command as CommandPrimitive } from "cmdk";
import { SearchIcon } from "lucide-react";
import { cn } from "@/utils/cn";

function Command({
  className,
  ...props
}: React.ComponentProps<typeof CommandPrimitive>) {
  return (
    <CommandPrimitive
      data-slot="command"
      className={cn(styles.command, className)}
      {...props}
    />
  );
}

function CommandInput({
  className,
  wrapperStyles,
  ...props
}: React.ComponentProps<typeof CommandPrimitive.Input> & {
  wrapperStyles?: React.CSSProperties;
}) {
  return (
    <div
      data-slot="command-input-wrapper"
      className={styles.commandInputWrapper}
      style={wrapperStyles}
    >
      <SearchIcon className={styles.searchIcon} />
      <CommandPrimitive.Input
        data-slot="command-input"
        className={cn(styles.commandInput, className)}
        {...props}
      />
    </div>
  );
}

function CommandList({
  className,
  ...props
}: React.ComponentProps<typeof CommandPrimitive.List>) {
  return (
    <CommandPrimitive.List
      data-slot="command-list"
      className={cn(styles.commandList, className)}
      onWheel={(e) => {
        e.currentTarget.scrollTop += e.deltaY;
      }}
      onWheelCapture={(e) => e.stopPropagation()}
      {...props}
    />
  );
}

function CommandEmpty({
  ...props
}: React.ComponentProps<typeof CommandPrimitive.Empty>) {
  return (
    <CommandPrimitive.Empty
      data-slot="command-empty"
      className={styles.commandEmpty}
      {...props}
    />
  );
}

function CommandGroup({
  className,
  ...props
}: React.ComponentProps<typeof CommandPrimitive.Group>) {
  return (
    <CommandPrimitive.Group
      data-slot="command-group"
      className={cn(styles.commandGroup, className)}
      {...props}
    />
  );
}

function CommandSeparator({
  className,
  ...props
}: React.ComponentProps<typeof CommandPrimitive.Separator>) {
  return (
    <CommandPrimitive.Separator
      data-slot="command-separator"
      className={cn(styles.commandSeparator, className)}
      {...props}
    />
  );
}

function CommandItem({
  className,
  ...props
}: React.ComponentProps<typeof CommandPrimitive.Item>) {
  return (
    <CommandPrimitive.Item
      data-slot="command-item"
      className={cn(styles.commandItem, className)}
      {...props}
    />
  );
}

function CommandShortcut({
  className,
  ...props
}: React.ComponentProps<"span">) {
  return (
    <span
      data-slot="command-shortcut"
      className={cn(styles.commandShortcut, className)}
      {...props}
    />
  );
}

export {
  Command,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
  CommandShortcut,
  CommandSeparator,
};
